<template>
    <div class="relative w-full pt-[85%]">
        <div
            class="video-item absolute top-0 left-0 w-full h-full flex flex-col mb-3 rounded-none sm:rounded-2xl border-0 border-birdie-grey-light bg-gray-200 overflow-hidden">

            <div class="skeleton-box w-full h-full flex flex-col items-center justify-end">
                <div class="flex-grow w-full bg-gray-300 flex items-center justify-center">
                    <PlayIcon class="w-12 h-12 text-gray-500 opacity-10"></PlayIcon>
                </div>
                <div class="w-full h-1/3 bg-gray-100 flex flex-col items-start justify-around px-4 py-3">
                    <div class="w-1/2 h-3 bg-gray-200 rounded-full"></div>
                    <div class="w-3/4 h-3 bg-gray-200 rounded-full"></div>
                    <div class="w-1/4 h-3 bg-gray-200 rounded-full"></div>
                </div>
            </div>

        </div>
    </div>

</template>

<script>

import { PlayIcon } from "@heroicons/vue/16/solid";


export default {
    components: {
        PlayIcon
    },
    props: {

    },
    data() {
        return {

        }
    },
    created() {
    },
    mounted() {
    },
    methods: {
    }
}

</script>

<style scoped>
.skeleton-box {
    position: relative;
}

.skeleton-box::after {
    display: block;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-size: cover;
    transform: translateX(-100%);
    background: linear-gradient(to right, transparent 0%, rgba(255, 255, 255, 0.5) 50%, transparent 100%);
    animation: shimmer 2s infinite;
    content: '';
}

@keyframes shimmer {
    100% {
        transform: translateX(100%);
    }
}
</style>
